/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-header-cell[_ngcontent-%COMP%]{font-size:medium;background-color:wheat}\n/*# sourceMappingURL=alert-report.component.css.map*/"];
export { styles as styles };
